/**
 * Token generation utility — single source of truth.
 *
 * Consolidates the three identical generateApiKey() copies that existed
 * in internal-auth.ts, auth/index.ts, and tokens.ts.
 */

/**
 * Generate a cryptographically random opaque token with the given prefix.
 * Format: `<prefix>_` + 32 bytes base64url-encoded.
 */
export function generateOpaqueToken(prefix: string): string {
  const bytes = new Uint8Array(32);
  crypto.getRandomValues(bytes);
  const base64 = btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');
  return `${prefix}_${base64}`;
}

/** Generate a cryptographically random `way_` API token. */
export function generateApiKey(): string {
  return generateOpaqueToken('way');
}
